import { render, staticRenderFns } from "./AttrHelpDot.vue?vue&type=template&id=718ca0a1&"
import script from "./AttrHelpDot.vue?vue&type=script&lang=js&"
export * from "./AttrHelpDot.vue?vue&type=script&lang=js&"
import style0 from "./AttrHelpDot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports